// The "Match page scale" option for the Frame Scale dropdown: offered only
// when at least one selected frame's clip scale differs from its own page's
// scale. Pure (no Svelte, no stores) so it is unit-testable under node --test.
import { getScaleLabel } from "@local/extensions/utilities/scales.js";

const MATCH_PAGE_SCALE = "__match_page__";

/**
 * Locations whose page carries a scale that differs from the frame's own.
 * A page with no scale offers nothing to match; clip-less locations can't
 * hold a scale at all.
 */
function mismatchedLocations(locations, pages) {
  return locations.filter((l) => {
    if (!l.clip) return false;
    const pageScale = pages[l.page_id]?.scale;
    return pageScale && (l.clip.drawing_scale ?? null) !== pageScale;
  });
}

/**
 * The dropdown option, or null when there is nothing to match. One distinct
 * page scale across the mismatches puts its label in the option; several
 * leave it bare — the apply is per-frame either way.
 */
function matchPageScaleOption(locations, pages) {
  const mismatched = mismatchedLocations(locations, pages);
  if (!mismatched.length) return null;

  const scales = new Set(mismatched.map((l) => pages[l.page_id].scale));
  const label =
    scales.size === 1
      ? `Match page scale: ${getScaleLabel([...scales][0])}`
      : "Match page scale";

  return { label, value: MATCH_PAGE_SCALE };
}

export { MATCH_PAGE_SCALE, matchPageScaleOption, mismatchedLocations };
